<template>
  <div class="basic-list">
    <div class="basic">
      <div class="item" v-for="(item, index) in equipmentList" :key="index">
        <div class="basic-name">
          <div class="line"></div>
          <div class="box">
            <span>{{ item.title }}</span>
            <div class="right-box"></div>
          </div>
        </div>
        <div class="list-wrap">
          <template v-for="(obj) in item.socketList">
            <template v-if="obj.dataType === 1">
              <div @click="chooseBase(item)" class="list-equip water-equip"
                :class="{'more': obj.socketList.length > 4, 'four': obj.socketList.length == 4, 'three': obj.socketList.length  <= 3}" :key="obj.id + 'sensor'">
                <div class="water-title">
                  <p>水质监控：</p>
                  <h4 :class="{ waterOnline: obj.powerStatus == 1 }" v-if="obj.powerStatus == 1">
                    {{ obj.name }}
                  </h4>
                  <h4 :class="{
                  waterOffline: obj.powerStatus == 0 || obj.powerStatus == 2,
                }" v-else>
                    {{ obj.name }}
                  </h4>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 0">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric0.png')" />
                    {{ "离线" }}
                    )
                  </div>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 1">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric1.png')" />
                    {{ "在线" }}
                    )
                  </div>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 2">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric2.png')" />
                    {{ "电池供电" }}
                    )
                  </div>
                </div>

                <div class="equip-params">
                  <p>
                    <span v-for="(m, index) in obj.socketList" :key="index" class="equip-params-span">
                      {{ m.name }}:
                      <span class="current-value"
                        :class="{ green: (m.lowerLimit < m.currentValue < m.upperLimit) && obj.powerStatus != 0, red: (m.currentValue < m.lowerLimit || m.currentValue > m.upperLimit) && obj.powerStatus != 0  }">{{windTran(m.measuredType, m.currentValue)}}
                        <font>{{ m.unitTitle }}</font>
                      </span>
                    </span>
                  </p>
                </div>
              </div>
            </template>
            <template v-else-if="obj.dataType === 2">
              <div class="list-equip remote-equip" @click="chooseBase(item)" :class="{'more': obj.socketList.length > 4, 'four': obj.socketList.length == 4}"
                :key="obj.id + 'switch'">
                <div class="remote-title">
                  <p>远程控制：</p>
                  <h4 :class="{ remoteOnline: obj.powerStatus == 1 }" v-if="obj.powerStatus == 1">
                    {{ obj.name }}
                  </h4>
                  <h4 :class="{
                  remoteOffline: obj.powerStatus == 0 || obj.powerStatus == 2,
                }" v-else>
                    {{ obj.name }}
                  </h4>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 0">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric0.png')" />
                    {{ "离线" }}
                    )
                  </div>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 1">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric1.png')" />
                    {{ "在线" }}
                    )
                  </div>
                  <div :class="{ outline: obj.powerStatus == 0 }" class="typeStatu" v-if="obj.powerStatus == 2">
                    (
                    <img class="equip-logo" :src="require('../../assets/images/Electric2.png')" />
                    {{ "电池供电" }}
                    )
                  </div>
                </div>
                <div class="equip-params">
                  <p :class="{three: obj.socketList.length  === 3}">
                    <span v-for="(m, index) in obj.socketList" :key="index" class="remote-params-span">
                      {{ m.name }}:
                      <span class="current-value">
                        (
                        <img class="switch-img" :src="
                        m.switchIsOpen
                          ? require('../../assets/images/lamp_open.png')
                          : require('../../assets/images/lamp_off.png')
                      " /><span>
                          {{ m.switchIsOpen ? "开" : "关" }}</span>
                        )</span>
                    </span>
                  </p>
                </div>
              </div>
            </template>

          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

// 调整浏览器显示比例【仅能查看】
import equipmentV2 from '../../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'BasicList',
  mixins: [mixins],
  data () {
    return {
      equipmentList: [],
      baseList: [],
      pondList: []
    }
  },
  watch: {},
  async mounted () {
    function pagePc () {
      let rootValue = 100
      let pc = rootValue / 1920 // 表示1366的设计图,使用100px的默认值
      let width = window.innerWidth // 当前窗口的宽度
      let height = window.innerHeight // 当前窗口的高度
      let rem = ''
      let currentHeight = (width * 798) / 1920
      if (height < currentHeight) {
        // 当前屏幕高度小于应有的屏幕高度，就需要根据当前屏幕高度重新计算屏幕宽度
        width = (height * 1920) / 798
      }
      rem = width * pc // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应font-size值
      document.documentElement.style.fontSize = rem + 'px'
    }

    pagePc()
    window.onresize = function () {
      pagePc()
    }
    this.setActiveTitle('')
    let list = await this.getEquipmentList()

    list.map((item) => {
      item.sensorEquipments.map((ytem) => {
        if (ytem.id === '636089367965017276') {
          ytem.socketList = [
            {
              currentValue: 1.01,
              name: '大气压',
              switchIsOpen: null,
              unitTitle: 'KPA'
            },
            {
              currentValue: 44.5,
              name: '适度',
              switchIsOpen: null,
              unitTitle: '%'
            },
            {
              currentValue: 450,
              name: '二氧化碳',
              switchIsOpen: null,
              unitTitle: 'PPM'
            },
            {
              currentValue: 20,
              name: '光照',
              switchIsOpen: null,
              unitTitle: 'LUX'
            },
            {
              currentValue: 8.39,
              name: '溶解氧',
              switchIsOpen: null,
              unitTitle: 'mg/l'
            },
            {
              currentValue: 101,
              name: '氧饱和度',
              switchIsOpen: null,
              unitTitle: '%'
            },
            {
              currentValue: 24.2,
              name: '水温',
              switchIsOpen: null,
              unitTitle: '%'
            },
            {
              currentValue: 25.2,
              name: '温度',
              switchIsOpen: null,
              unitTitle: '%'
            },
            {
              currentValue: 7.42,
              name: 'PH值',
              switchIsOpen: null,
              unitTitle: ''
            },
            {
              currentValue: 0.023,
              name: '氨氮',
              switchIsOpen: null,
              unitTitle: 'mg/l'
            }
          ]
        }
      })
    })

    if (list && list.length) {
      list.forEach((equip) => {
        let socketList = []
        equip.sensorEquipments && equip.sensorEquipments.forEach((item) => {
          item.dataType = 1
          socketList.push(item)
        })
        equip.switchEquipments && equip.switchEquipments.forEach((item) => {
          item.dataType = 2
          socketList.push(item)
        })
        socketList.sort((a, b) => {
          return a.name > b.name ? 1 : -1
        }).sort((a, b) => {
          return a.id > b.id ? 1 : -1
        }).sort((a, b) => {
          return b.powerStatus - a.powerStatus
        })
        equip.socketList = socketList
      })
    }
    console.log(666, list)
    this.equipmentList = list
  },
  computed: {
    ...mapState(equipmentV2, ['currentEnterprise'])
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentList']),
    ...mapMutations(equipmentV2, ['setChooseBasic', 'setActiveTitle']),
    // 风向转换
    windTran (type, title) {
      if (type === 16) {
        let result = ''
        switch (title) {
          case 0:
            result = '北风'
            break
          case 45:
            result = '东北风'
            break
          case 90:
            result = '东风'
            break
          case 135:
            result = '东南风'
            break
          case 180:
            result = '南风'
            break
          case 225:
            result = '西南风'
            break
          case 270:
            result = '西风'
            break
          case 315:
            result = '西北风'
            break
          default:
            result = title
        }
        return result
      } else {
        return title
      }
    },
    // 选择基地
    chooseBase (item) {
      localStorage.setItem('currentBasic', JSON.stringify(item))
      localStorage.setItem('currentEnterprise', this.currentEnterprise.id)
      this.setChooseBasic(item)
      this.getEquipmentData(item)
      this.$router.push({
        name: 'equipmentControl'
      })
    },
    // 时间过滤
    timeSplit (value) {
      return value.replace('T', ' ')
    }
  }
}
</script>
<style lang="scss">
.waterOffline,
.remoteOffline {
  color: #828ca2;
}
.waterOnline {
  color: #87ee22;
}
.remoteOnline {
  color: #38e4fe;
}
.typeStatu {
  margin-left: 0.2rem;
  color: #777d8b;
}
.basic-list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  overflow-x: hidden;
  .basic {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding-top: 0.2rem;
    .basic-name {
      width: 100%;
      // padding: 0 0.25rem;
      line-height: 0.85rem;
      font-size: 0.24rem;
      color: white;
      position: relative;
      // margin: 0 0.25rem;
      height: 0.45rem;
      line-height: 0.44rem;
      text-align: center;
      .line {
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, #148eff, #148eff);
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .box {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-self: center;
        display: inline-block;
        transform: skewX(-25deg);
        height: 0.45rem;
        margin-right: 0.1rem;
        padding-right: 0.06rem;
        font-size: 0.18rem;
        color: #fefefe;
        border: 1px solid #148eff;
        margin-left: 0.1rem;
        padding: 0 0.25rem;
        span {
          transform: skewX(25deg);
        }
        .right-box {
          width: 0.1rem;
          height: 0.45rem;
          border: 1px solid #148eff;
          position: absolute;
          right: -0.1rem;
          top: -1px;
        }
      }
    }
    .list-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .item {
      width: 100%;
      padding: 0.05rem 0.25rem;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .list-equip {
      display: flex;
      width: 48%;
      // min-height: 100px;
      padding: 0.12rem 0px;
      margin-bottom: 0.2rem;
      flex-direction: column;
      // &.three {
      //   width: 30%;
      // }
      > p {
        font-size: 0.22rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777d8b;
      }
      .equip-params {
        // width: 68%;
        display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        h4 {
          font-size: 0.18rem;
          color: #87ee22;
        }
        p {
          display: flex;
          font-size: 0.18rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #b7bcc6;
          .equip-params-span,
          .remote-params-span {
            min-width: 2.3rem;
          }
        }
      }

      &.more,
      &.more + .list-equip {
        width: 100%;
        // flex-direction: row;
        align-items: baseline;
        .water-title,
        .remote-title {
          flex-shrink: 0;
          // width: 3.18rem;
        }
        .equip-params {
          p {
            flex-wrap: wrap;
            .equip-params-span,
            .remote-params-span {
              margin-bottom: 0.12rem;
              // margin-right: 0.79rem;
              // min-width: 2rem;
            }
          }
        }
      }
      // &.four {
      //   .equip-params {
      //     p {
      //       width: 100%;
      //       justify-content: space-between;
      //     }
      //   }
      // }
    }
    .water-equip,
    .remote-equip {
      // flex-direction: column;
      .water-title,
      .remote-title {
        display: flex;
        align-items: center;
        font-size: 0.22rem;
        p {
          color: #777d8b;
        }
      }
      .equip-params {
        font-size: 0.14rem;
        margin-top: 0.15rem;
        width: 100%;
      }
      .equip-params-span {
        // margin-right: 1.1rem;
        &:last-child {
          margin-right: 0;
        }
      }
      .remote-params-span {
        // margin-right: 0.3rem;
        &:last-child {
          margin-right: 0;
        }
      }
      .current-value {
        font-size: 0.22rem !important;
        .switch-img {
          width: 0.12rem;
          height: 0.13rem;
          margin: 0 0.15rem 0 0.1rem;
        }
        &.green {
          color: #00d53c;
        }
        &.red {
          color: #e92910;
        }
        font {
          font-size: 0.18rem;
        }
      }
    }
  }
}
</style>
